<textarea nz-input
            [(ngModel)]="statusChangeComment"
            placeholder="Komentārs"
            [nzAutosize]="{ minRows: 2, maxRows: 6 }"></textarea>
